module.exports = __webpack_public_path__ + "img/31.6d9acf5b.svg";